const ICON_URL_BASE = 'https://s2.googleusercontent.com/s2/favicons?domain=';

export const getSiteIcon = (url: string): string => `${ICON_URL_BASE}${url}`;
